import React, { useState, useEffect, useRef } from 'react';

import NoImage from './no-image.svg';
import { getContainerStyle, getImageStyle } from './image-service';
import { Figure } from './image.style';

export default function Image(props: Props) {
    const container = useRef<HTMLElement>(null);
    const imageEl = useRef<HTMLImageElement>(null);
    const { alt, className, datasrc, fetchPriority, height, imageClasses, src, width, shouldSetContainerStyles } =
        props;

    const [imageStyle, setImageStyle] = useState({});

    const setImageStyles = () => {
        // @ts-ignore
        setImageStyle(getImageStyle(container, imageEl));
    };

    useEffect(() => {
        const image = imageEl.current;
        if (image && image.complete && !('object-fit' in image.style)) {
            setImageStyles();
        }
    });

    const imageSrc = datasrc || src;

    return (
        <Figure
            {...(shouldSetContainerStyles && {
                style: getContainerStyle(height, width),
            })}
            noSrc={!src}
            className={className}
            ref={container}
        >
            {datasrc || src ? (
                <img
                    suppressHydrationWarning
                    className={imageClasses}
                    alt={alt}
                    onLoad={setImageStyles}
                    ref={imageEl}
                    style={imageStyle}
                    {...(src ? { src: imageSrc } : {})}
                    {...(datasrc ? { 'data-src': imageSrc } : {})}
                    {...(fetchPriority ? { fetchPriority } : {})}
                />
            ) : (
                <NoImage />
            )}
        </Figure>
    );
}

Image.defaultProps = {
    alt: undefined,
    className: undefined,
    datasrc: undefined,
    height: undefined,
    imageClasses: undefined,
    shouldSetContainerStyles: true,
    src: undefined,
    width: undefined,
};

export interface Props {
    alt?: string;
    className?: string;
    datasrc?: string;
    fetchPriority?: 'high' | 'low' | 'auto';
    height: number | null;
    imageClasses?: string;
    shouldSetContainerStyles?: boolean;
    src?: string;
    width: number | null;
}

